import { useTranslation } from 'react-i18next';
import { Box, Paper, Title, CloseButton, Icon } from './CookieStatementPopup.styled';
import CookieStatementContent from 'components/CookieStatement/CookieStatementContent';

type CookieStatementPopupProps = {
  onClose: () => void;
};

const CookieStatementPopup = (props: CookieStatementPopupProps) => {
  const { t } = useTranslation();

  return (
    <Paper>
      <CloseButton onClick={props.onClose} size="large">
        <Icon>close</Icon>
      </CloseButton>
      <Title variant="h4">
        {t('cookies.cookiebar.title')}
      </Title>
      <Box>
        <CookieStatementContent />
      </Box>
    </Paper>
  );
};

export default CookieStatementPopup;
